import {Component} from "react";
import {BottomNavigation, BottomNavigationAction, Stack, Typography} from "@mui/material";
import LayersIcon from "@mui/icons-material/Layers";
import {connect} from "react-redux";
import {mapAnnotationStateToProps} from "../../../redux_reducers/utils";
import {getEyeCheckbox} from "../components/components";
import {annotationsApp, deepBioApp, ihcApp} from "../app_maker";
import {isOpenLayersMap} from "../utils/map_utils";

class LayersControl extends Component {

	layers = [
		{
			id: annotationsApp.id,
			label: 'Annotation Layer',
			enablementNotRequired: 'tileMapEnable'
		},
		{
			id: deepBioApp.id,
			label: 'DeepBio Layer',
		},
		{
			id: ihcApp.id,
			label: 'IHC Layer',
		},
		{
			id: 'field',
			label: 'Field Layer',
			enablementRequired: 'bloodMapEnable'
		},
		{
			id: 'WBCLayer',
			label: 'WBC Layer',
			enablementRequired: 'bloodMapEnable'
		},
		{
			id: 'RBCLayer',
			label: 'RBC Layer',
			enablementRequired: 'bloodMapEnable'
		},
		{
			id: 'PLTLayer',
			label: 'PLT Layer',
			enablementRequired: 'bloodMapEnable'
		},
		{
			id: 'deep-bio-analysis',
			label: 'DeepBio Analysis Layer',
		},
		{
			id: 'ihc-result',
			label: 'IHC Result Layer',
		},
		{
			id: 'tileViewApp.id',
			label: 'Tile Annotation Layer',
			enablementRequired: 'tileMapEnable'
		}
	];

	constructor(props) {
		super(props);
		this.state = {
			openLayersPanel: false,
		}
	}

	getLayerRow(layerId, layerLabel) {
		if (!isOpenLayersMap(this.props.slidemap)) return null;
		let layer = this.props.slidemap.getLayers().getArray().find(layer => layer.get("id") === layerId);

		if(layer) {
			let isLayerVisible = layer.getVisible();
			return (
				<Stack key={layerId} direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
					{getEyeCheckbox(isLayerVisible, undefined, () => {layer.setVisible(!isLayerVisible); this.setState({});})}
					<Typography variant={"caption"} color={"whitesmoke"}>{layerLabel}</Typography>
				</Stack>
			)
		}
	}
	
	layerController() {
		return (<Stack direction={"column"} padding={1} bgcolor={"rgba(51, 4, 112,0.8)"}>
					{this.layers.filter(layer => ((!layer.enablementRequired && !layer.enablementNotRequired) || 
													(layer.enablementRequired && this.props[ layer.enablementRequired ]) ||
													((layer.enablementNotRequired && !this.props[ layer.enablementNotRequired ])) ))
					.map(layer => this.getLayerRow(layer.id, layer.label))}
				</Stack>);
	}

	render() {
		const canOpenLayersPanel = isOpenLayersMap(this.props.slidemap);
		return <Stack direction={"column-reverse"} alignItems={"flex-end"} className='LayersControl-forTour'>
			<BottomNavigation sx={{borderRadius: 0, opacity: 0.8}} value={this.state.app}
			                  onChange={() => canOpenLayersPanel &&
				                  this.setState({openLayersPanel: !this.state.openLayersPanel,})}>
				<BottomNavigationAction
					icon={this.state.openLayersPanel ? <LayersIcon color="secondary"/> : <LayersIcon/>}
					disabled={!canOpenLayersPanel}
					sx={{padding: 0}}/>
			</BottomNavigation>
			{this.state.openLayersPanel && canOpenLayersPanel && this.layerController()}
		</Stack>
	}
}

export default connect(mapAnnotationStateToProps)(LayersControl)
